import React, { useState, useEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { CircularProgress, Box, InputAdornment, IconButton } from "@mui/material";
import { IoIosSearch, IoMdClose } from "react-icons/io";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import Header from "../../Home/Header/Header";
import CustomTextField from "../../../TextFiled/Index";
import "./StockReport.scss";

const StockReport = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const gridRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 130}px`;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("Report_Stock")
      .then((response) => {
        if (response?.Data?.DT) {
          const formattedData = response.Data.DT.map((item, index) => ({
            ...item,
            id: index + 1,
            Categoryname: `${item.Categoryname}`,
            SubCategoryname: `${item.SubCategoryname}`,
            GrossNet: `GW: ${item.Grosswt.toFixed(
              3
            )} / NW: ${item.Netwt.toFixed(3)}`,
            DctwCsctw: `Dctw: ${item.Dctw.toFixed(
              3
            )} / Csctw: ${item.Csctw.toFixed(3)}`,
          }));
          setSaleData(formattedData);
          setFilteredData(formattedData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to fetch stock data. Please try again.");
        setIsLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchQuery(searchValue);
    const filteredSales = saleData.filter(
      (sale) =>
        sale.CustomerCode.toLowerCase().includes(searchValue) ||
        sale.Categoryname.toLowerCase().includes(searchValue) ||
        sale.SubCategoryname.toLowerCase().includes(searchValue)
    );
    setFilteredData(filteredSales);
  };

  const columns = [
    {
      field: "CustomerCode",
      headerName: "Customer Code",
      width: 150,
    },

    {
      field: "JobCount",
      headerName: "Job Count",
      width: 100,
    },
    {
      field: "Categoryname",
      headerName: "Category",
      width: 130,
      renderCell: (params) => {
        return `${params.row.Categoryname}`;
      },
    },

    {
      field: "SubCategoryname",
      headerName: "Sub-Category",
      width: 150,
      renderCell: (params) => {
        return `${params.row.SubCategoryname}`;
      },
    },
    {
      field: "GrossNet",
      headerName: "GWt / NWt",
      width: 120,
      renderCell: (params) => {
        return (
          <div className="twocolum_mainDiv">
            <div
              style={{ display: "flex", height: "20px", alignItems: "center" }}
            >{`GW: ${params.row.Grosswt.toFixed(3)}`}</div>
            <div
              style={{ display: "flex", height: "20px", alignItems: "center" }}
            >{`NW: ${params.row.Netwt.toFixed(3)}`}</div>
          </div>
        );
      },
    },
    {
      field: "DctwCsctw",
      headerName: "Dctw / Csctw",
      width: 120,
      renderCell: (params) => {
        return (
          <div className="twocolum_mainDiv">
            <div
              style={{ display: "flex", height: "20px", alignItems: "center" }}
            >{`Dia: ${params.row.Dctw.toFixed(3)}`}</div>
            <div
              style={{ display: "flex", height: "20px", alignItems: "center" }}
            >{`CS: ${params.row.Csctw.toFixed(3)}`}</div>
          </div>
        );
      },
    },
  ];

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredData(saleData);
  };

  return (
    <div className="employee_main">
      {/* {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )} */}
      <Header otherPage={true} title="Stock Report" />
      <div style={{ padding: "65px 5px 5px 5px" }}>
        <Box mb={2}>
        <CustomTextField
            className="searchBox_input"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search ..."
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton onClick={clearSearch}>
                  <IoMdClose className="catelog_searchClose_icone" />
                </IconButton>
              ),
            }}
          />
        </Box>
        <div
          ref={gridRef}
          style={{
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <DataGrid
            rows={filteredData || []}
            columns={columns}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15, 25, 50]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pagination
            loading={isLoading}
            localeText={{ noRowsLabel: "No Data" }}
            components={{
              Toolbar: () => null,
              LoadingOverlay: () => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  Loading...
                </div>
              ),
            }}
            className="employee_datagrid"
          />
        </div>
      </div>
    </div>
  );
};

export default StockReport;
